import { useContext, useMemo, useState } from 'react';
import { ConfigContext } from '../../context';
import { ConfigCustomEmojis } from '../../services';

interface UseCustomEmojiArgs {
  emojiKey: keyof ConfigCustomEmojis;
  size: number;
}

export const useCustomEmoji = ({ emojiKey, size }: UseCustomEmojiArgs) => {
  const { customEmojis } = useContext(ConfigContext).config.elements;

  const [brokenUrl, setBrokenUrl] = useState('');

  const url = customEmojis?.[emojiKey];

  const customEmoji = useMemo(() => {
    if (!url || url === brokenUrl) {
      return null;
    }

    return <img src={url} width={size} height={size} alt={''} onError={() => setBrokenUrl(url)} />;
  }, [brokenUrl, size, url]);

  return { customEmoji };
};
